// Copyright (c) 2023 Deere & Company

import './index.scss';
import React, {
    Component,
    PropTypes
} from 'react';
import Attachments from './attachment';
import DuplicatePinPlate from '@deere/cps-it.warranty-model-factory/lib/duplicate-pin-plate';
import {FormattedMessage} from 'react-intl';
import LabeledString from '../../../../shared/components/labeled-string';
import {Link} from 'react-router';
import {buildDate} from '../../../../shared/services/build-date';
import {buildDealer} from '../../../../shared/services/build-dealer';

class DuplicatePinPlateResult extends Component {

    constructor() {

        super();
        this.handleAccept = this.handleAccept.bind(this);
        this.handleDecline = this.handleDecline.bind(this);
        this.handleComplete = this.handleComplete.bind(this);

    }
    handleAccept() {

        const pinPlate = {...this.props.duplicatePlate};

        pinPlate.status = 'APPROVED';

        this.props.actions.updateDuplicatePinPlateStatus(pinPlate, this.props.selectedDealers);

    }

    handleDecline() {

        const pinPlate = {...this.props.duplicatePlate};

        pinPlate.status = 'REJECTED';

        this.props.actions.updateDuplicatePinPlateStatus(pinPlate, this.props.selectedDealers);

    }

    handleComplete() {

        const pinPlate = {...this.props.duplicatePlate};

        pinPlate.status = 'COMPLETED';

        this.props.actions.updateDuplicatePinPlateStatus(pinPlate, this.props.selectedDealers);

    }

    render() {

        return (
            <section className='spa-result'>
                <header>
                    <section className='spa-title'>
                        <span>
                            <Link
                                className='product-title'
                                rel='noopener noreferrer'
                                target='_blank'
                                to={`/products/${this.props.duplicatePlate.pin}`}
                            >
                                <FormattedMessage
                                    id={this.props.duplicatePlate.pin}
                                ></FormattedMessage>
                            </Link>
                        </span>

                    </section>
                </header>
                <div className='spa-details'>
                    <div className='row'>
                        <LabeledString
                            className='reference1'
                            data={this.props.duplicatePlate.machineModel}
                            label='MACHINE_MODEL_TYPE'
                        />
                        <LabeledString
                            className='pin'
                            data={this.props.duplicatePlate.pin}
                            label='PIN'
                        />
                        <LabeledString
                            className='customer-contribution'
                            data={buildDate(this.props.duplicatePlate.dateSubmmited)}
                            label='DATE_SUBMITTED'
                        />
                    </div>
                    <div className='row'>
                        <LabeledString
                            className='status-value'
                            data={this.props.duplicatePlate.status}
                            label='STATUS'
                        />
                        <LabeledString
                            className='submitted-date'
                            data={this.props.duplicatePlate.requesterTCSM}
                            label='REQUESTER_TCSM'
                        />
                        <LabeledString
                            className='dealer-contribution'
                            data={this.props.duplicatePlate.mailingRecipient}
                            label='RECIPIENT_MAILING'
                        />
                    </div>
                    <div className='row'>
                        <LabeledString
                            className='responsible-account lost-two-column'
                            data={buildDealer(this.props.duplicatePlate.dealer)}
                            label='RESPONSIBLE_DEALER'
                        />
                        <LabeledString
                            className='company-contribution'
                            data={this.props.duplicatePlate.factory}
                            label='FACTORY'
                        />
                    </div>
                    <div className='row'>
                        <LabeledString
                            className='created-by'
                            data={this.props.duplicatePlate.createdBy}
                            label='CREATED_BY'
                        />
                        <LabeledString
                            className='submitted-date'
                            data={this.props.duplicatePlate.missingPlateReason}
                            label='REASON_FOR_MISSING_PLATE'
                        />
                        <LabeledString
                            className='dealer-contribution'
                            data={this.props.duplicatePlate.shippingId}
                            label='SHIPPING_ID'
                        />
                    </div>
                    <div className='row'>
                        <Attachments files={this.props.duplicatePlate.file}/>
                    </div>

                    <footer>
                        <section className='button-group'>
                            {this.props.duplicatePlate.status === 'SHIPPED' &&
                            <button
                                className='primary'
                                onClick={this.handleComplete}
                            >
                                <FormattedMessage id='COMPLETE'/>
                            </button>
                            }
                            {this.props.duplicatePlate.status === 'SUBMITTED' &&
                            <button
                                className='secondary'
                                onClick={this.handleDecline}
                            >
                                <FormattedMessage id='REJECT'/>
                                </button>
                            }
                            {this.props.duplicatePlate.status === 'SUBMITTED' &&
                            <button
                                className='primary'
                                onClick={this.handleAccept}
                            >
                                <FormattedMessage id='APPROVE'/>
                            </button>
                            }
                        </section>
                    </footer>

                </div>
            </section>
        );

    }
    }

DuplicatePinPlateResult.displayName = 'DuplicatePinPlateResult';
DuplicatePinPlateResult.propTypes = {
    actions: PropTypes.object.isRequired,
    duplicatePlate: PropTypes.instanceOf(DuplicatePinPlate).isRequired,
    selectedDealers: PropTypes.arrayOf(PropTypes.instanceOf(String))
};

export default DuplicatePinPlateResult;



// WEBPACK FOOTER //
// ./src/tcsm/wip/components/duplicate-pin-plate/duplicate-pin-plate-result.js